import {Component, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {UserService} from "../../../services/user.service";
import {RegistryService} from '../../../services/registry.service';
import {AuthService} from '../../../../../services/auth.service';
import {UserAddressesComponent} from './user-addresses/user-addresses.component';
import {CustomerAddress} from '../../../models/CustomerInfo/CustomerAddress';
import {MagentoCustomerService} from '../../../../../services/magentocustomer.service';
import {Customer} from '../../../models/CustomerInfo/Customer';
import {MatSnackBar} from '@angular/material/snack-bar';
import {environment} from '../../../../../environments/environment';
import {CartService} from '../../../services/cart.service';
import {Cart} from '../../../models/CartModels/cart';
import {Subject} from "rxjs";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit, OnDestroy {
    // error_message = null;
    // registrationSuccess = false;
    // profileForm = new FormGroup({
    //     firstname: new FormControl('', Validators.required),
    //     lastname: new FormControl('', Validators.required),
    //     email: new FormControl('', [Validators.required, Validators.email]),
    //     password: new FormControl('', Validators.required),
    // });


    // newUser: User = new class implements User {
    //     customer: Customer = new class implements Customer {
    //         email: string;
    //         firstname: string;
    //         lastname: string;
    //     };
    //     password: string;
    // };
    //
    //
    // getEmailErrorMessage() {
    //     if (this.profileForm.controls['email'].hasError('required')) {
    //         return 'You must enter a value';
    //     }
    //
    //     return this.profileForm.controls['email'].hasError('email') ? 'Not a valid email' : '';
    // }
    //
    // getFirstNameErrorMessage() {
    //     if (this.profileForm.controls['firstname'].hasError('required')) {
    //         return 'You must enter a value';
    //     }
    //
    //     return this.profileForm.controls['firstname'].hasError('firstname') ? 'Not a valid name' : '';
    // }
    //
    // getLastNameErrorMessage() {
    //     if (this.profileForm.controls['lastname'].hasError('required')) {
    //         return 'You must enter a value';
    //     }
    //
    //     return this.profileForm.controls['lastname'].hasError('lastname') ? 'Not a valid name' : '';
    // }
    //
    // getPasswordErrorMessage() {
    //     if (this.profileForm.controls['password'].hasError('required')) {
    //         return 'You must enter a value';
    //     }
    //
    //     return this.profileForm.controls['password'].hasError('password') ? 'Not a valid password' : '';
    // }
    //
    // getConfirmPasswordErrorMessage() {
    //     if (this.profileForm.controls['cPassword'].hasError('required')) {
    //         return 'You must enter a value';
    //     }
    //
    //     return this.profileForm.controls['cPassword'].hasError('password') ? 'Not a valid password' : '';
    // }


    @Output() showLoginSelectedEvent = new Subject();
    isLoggingIn = false;

    signUpForm = new FormGroup({

        new_email: new FormControl('', Validators.required),
        new_password: new FormControl('', Validators.required),
        first_name: new FormControl('', Validators.required),
        last_name: new FormControl('', Validators.required),
        confirm_password: new FormControl('', Validators.required),
        address_first_name: new FormControl('', Validators.required),
        address_last_name: new FormControl('', Validators.required),
        city: new FormControl('', Validators.required),
        street: new FormControl('', Validators.required),
        phone: new FormControl('', [Validators.pattern('^[0-9]*$'), Validators.required]),
    });

    customer_type = null;
    customer: Customer = new Customer();
    address: CustomerAddress[] = [];

    status = null;
    cart: Cart;

    userLoggedEvent
    customerLoadedEvent

    emailExists = false;


    constructor(public dialog: MatDialog,
                private translate: TranslateService,
                private authService: AuthService, private snackBar: MatSnackBar, private cartService: CartService, private registry: RegistryService, public userService: UserService, private customerService: MagentoCustomerService,) {
        this.userLoggedEvent = this.authService.UserLoggedInEvent$.subscribe(customer => {

            this.status = 'loggedin';
            this.customer = customer;

        });

        this.customerLoadedEvent = this.registry.CustomerLoadedEvent$.subscribe(customer => {

            this.status = 'loggedin';
            this.customer = customer;

        });
    }

    ngOnDestroy(): void {

        this.userLoggedEvent.unsubscribe();
        this.customerLoadedEvent.unsubscribe();
    }

    changeAddressFirstName(value2) {

        this.signUpForm.controls['address_first_name'].setValue(value2, {onlySelf: true});
    }

    changeAddressLastName(value) {

        this.signUpForm.controls['address_last_name'].setValue(value, {onlySelf: true});
    }


    ngOnInit(): void {

        if (this.registry.customer != null) {
            this.customer = this.registry.customer;
            this.status = 'loggedin';
        }

    }

    checkEmailExists() {

        let email = this.signUpForm.value.new_email
        this.customerService.isEmailAvailable(email).subscribe(result => {

            this.emailExists = result;

        })
    }

    showLogin(event) {
        event.preventDefault();


        this.showLoginSelectedEvent.next();
        // console.log(this.parent);
        // if (this.parent != null) {
        //     this.parent.setCheckoutCustomerType('current_customer');
        // } else {
        //
        // }
    }

    // for create a new user
    setUpCustomerAddress() {

        const new_address = new CustomerAddress();
        new_address.firstname = this.signUpForm.value.address_first_name;
        new_address.lastname = this.signUpForm.value.address_last_name;
        new_address.city = this.signUpForm.value.city;
        new_address.street = [this.signUpForm.value.street];
        new_address.telephone = this.signUpForm.value.phone;
        new_address.country_id = environment.defaultCountry;
        new_address.id = null;
        return new_address;

    }

    signUp() {
        const email = this.signUpForm.value.new_email;
        const password = this.signUpForm.value.new_password;
        const firstName = this.signUpForm.value.first_name;
        const lastName = this.signUpForm.value.last_name;
        const confirmPassword = this.signUpForm.value.confirm_password;
        const quoteId = this.registry.Quote_id;




        if (password != confirmPassword) {


            this.translate.get('passwords_do_not_match', {}).subscribe((res: string) => {
                this.openSuccessSnackBar(res, null);

            });
            return;
        }

        this.isLoggingIn = true;
        const customer_info = {

            customer: {
                firstname: firstName,
                lastname: lastName,
                email: email
            },
            password: password,
        }
        this.address.push(this.setUpCustomerAddress());


        this.userService.signUp(customer_info).subscribe(data => {


            this.cartService.getGuestCart(quoteId,this.registry.getWebsiteId()).subscribe(cart => {
                this.cart = cart;
                // localStorage.setItem('cart_items', JSON.stringify(this.cart));


                this.authService.customerAuthentication(email, password).subscribe(token => {

                    // setup the user
                    localStorage.setItem('customer_type', 'user');
                    localStorage.setItem('t', String(token));


                    this.registry.setupCustomer().subscribe(success => {
                        },
                        failure => {
                            this.registry.customer.addresses = this.address;
                            this.registry.customer.websiteId = this.registry.getWebsiteId();
                            this.cartService.getCustomerCart(this.registry.getWebsiteId()).subscribe(cart => {
                                this.registry.cart = cart;
                                this.cartService.cart = cart;
                                this.registry.cart.quoteId = this.cart.id.toString();
                                this.registry.cart.cartType = 'user';
                                this.cartService.setCachedCartId('user', this.cart.id);
                                this.cartService.EmitCartUpdated(cart);
                                this.customerService.updateCustomerData(this.registry.customer).subscribe(result => {
                                    for (let i = 0; i < this.cart.items.length; i++) {

                                        this.cartService.addItemToCart(this.registry.cart, this.cart.items[i].sku, this.cart.items[i].qty).subscribe(resp => {
                                            // user
                                            this.cartService.getCustomerCart(this.registry.getWebsiteId()).subscribe(cart => {
                                                cart.cartType = 'user';
                                                cart.quoteId = this.cart.id.toString();
                                                this.registry.cart = cart;
                                                this.cartService.cart = cart;
                                                this.cartService.EmitCartUpdated(cart);
                                            });

                                        });

                                    }
                                });
                            })


                        }
                    );


                });


            });


        }, error => {
            console.log(error.error.message);
        });


    }

    // Snackbar that opens with success background
    openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
            horizontalPosition: "right",
            panelClass: ['primary-snackbar'],
        });
    }


    openAddressDialog(id: number) {

        const dialogRef = this.dialog.open(UserAddressesComponent, {
            width: '750px',
            data: {id: id, parent: this}

        });

    }

    login(email, password) {


        const quoteId = this.registry.Quote_id;


        if (quoteId != undefined) {

            this.cartService.getGuestCart(quoteId,this.registry.getWebsiteId()).subscribe(cart => {
                this.cart = cart;
                // localStorage.setItem('cart_items', JSON.stringify(this.cart));


                this.authService.customerAuthentication(email, password).subscribe(token => {

                    // setup the user
                    localStorage.setItem('customer_type', 'user');
                    localStorage.setItem('t', String(token));


                    this.registry.setupCustomer().subscribe(success => {
                            const cartId = localStorage.getItem('cartId');

                            this.registry.customer.addresses = this.address;
                            this.registry.customer.websiteId = this.registry.getWebsiteId();
                            this.customerService.updateCustomerData(this.registry.customer).subscribe(result => {

                                for (let i = 0; i < this.cart.items.length; i++) {

                                    this.cartService.addItemToCart(this.registry.cart, this.cart.items[i].sku, this.cart.items[i].qty).subscribe(resp => {
                                        // user
                                        this.cartService.getCustomerCart(this.registry.getWebsiteId()).subscribe(cart => {
                                            cart.cartType = 'user';
                                            cart.quoteId = cartId;
                                            this.registry.cart = cart;
                                            this.cartService.cart = cart;
                                            this.cartService.EmitCartUpdated(cart);
                                        });

                                    });

                                }

                            });
                        },
                        failure => {
                            // this.registry.customer.addresses = this.address;
                            // this.registry.customer.websiteId = 1;
                            // console.log(this.registry.customer);
                            // this.customerService.updateCustomerData(this.registry.customer).subscribe(result => {
                            //
                            // });

                        }
                    );


                });


            });
        } else {
            this.authService.customerAuthentication(email, password).subscribe(token => {

                    // setup the user
                    localStorage.setItem('customer_type', 'user');
                    localStorage.setItem('t', String(token));

                    this.registry.setupCustomer().subscribe(success => {
                            this.registry.customer.addresses = this.address;
                            this.registry.customer.websiteId = this.registry.getWebsiteId();
                            this.customerService.updateCustomerData(this.registry.customer).subscribe(result => {

                            });

                        },
                        failure => {
                            this.registry.customer.addresses = this.address;
                            this.registry.customer.websiteId = this.registry.getWebsiteId();
                            this.customerService.updateCustomerData(this.registry.customer).subscribe(result => {

                            });
                        }
                    );

                },
                error => {

                    this.openSuccessSnackBar(error.error.message, null);

                    // alert(error.error.message);
                }
            );

        }

    }

}
